export enum ToastType {
    Success,
    Information,
    Warning,
    Danger,
}
